import {Injectable} from "@angular/core";
import {CanActivate, Router} from "@angular/router";
import {AuthService} from "./auth.service";
import {TdDialogService} from "@covalent/core/dialogs";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private customAuthService: AuthService,
              private ds: TdDialogService) {
  }

  canActivate(): boolean {
    const token = this.customAuthService.getUser()?.token; // Assuming the token is stored in localStorage

    if (token) {
      if (this.checkLastLoginDate()) {
        return true;
      } else {
        this.customAuthService.logout()
        this.ds.openAlert({
          message: "Session invalid. Please log in again."
        });
        return false;
      }

      return true;
    } else {
      this.customAuthService.logout();
      this.ds.openAlert({
        message: "Session invalid. Please log in again."
      });
      return false;
    }
  }

  checkLastLoginDate(): boolean {
    const lastLoginDate = this.customAuthService.getLastLoginDate();

    if (lastLoginDate) {
      const now = new Date();
      const diffInHours = (now.getTime() - lastLoginDate.getTime()) / (1000 * 60 * 60);
      return diffInHours <= 24;
    }
    return false;
  }
}
